// ------------------------------------
// Depoimentos (Carrosel)
// ------------------------------------
const $depoimentosCarrosel = $('#carrosel-depoimentos');
const $depoVideosCarrosel = $('#carrosel-depoimentos-videos');
const $depoImagensCarrosel = $('#carrosel-depoimentos-imagens');

depoimentosInitSlick();
depoVideosInitSlick();
depoImagensInitSlick();

// Desabilita o plugin de carrosel
function depoimentosDestroySlick() {
  if ($depoimentosCarrosel.hasClass('slick-slider')) {
    $depoimentosCarrosel.slick('unslick');
  }
}
function depoVideosDestroySlick() {
  if ($depoVideosCarrosel.hasClass('slick-slider')) {
    $depoVideosCarrosel.slick('unslick');
  }
}
function depoImagensDestroySlick() {
  if ($depoImagensCarrosel.hasClass('slick-slider')) {
    $depoImagensCarrosel.slick('unslick');
  }
}

// Aplica o plugin de carrosel
function depoimentosInitSlick() {
  const dots = $depoimentosCarrosel.find('.carousel-item').length > 3;
  $depoimentosCarrosel.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: dots,
    //speed: 1000,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      // Mobile
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
function depoVideosInitSlick() {
  const dots = $depoVideosCarrosel.find('.carousel-item').length > 3;
  $depoVideosCarrosel.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: dots,
    infinite: true,
    //speed: 1000,
    autoplay: false,
    adaptiveHeight: true,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      // Mobile
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}
function depoImagensInitSlick() {
  const dots = $depoImagensCarrosel.find('.carousel-item').length > 4;
  $depoImagensCarrosel.slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: dots,
    infinite: true,
    //speed: 1000,
    autoplay: false,
    adaptiveHeight: false,
    // Responsivo
    responsive: [
      // Tablet
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      // Mobile
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

slickReinitLazy($depoimentosCarrosel, depoimentosInitSlick, depoimentosDestroySlick);
slickReinitLazy($depoVideosCarrosel, depoVideosInitSlick, depoVideosDestroySlick);
slickReinitLazy($depoImagensCarrosel, depoImagensInitSlick, depoImagensDestroySlick);
